import React, { Component } from "react";
import { Grid, Divider } from "semantic-ui-react";
class PaidInv extends Component {
    HandleHeader() {
        if (this.props.invoices) {
            if (this.props.invoices.length > 0) {
                return "The Following Invoices paid in full";
            } else {
                return "There are no paid invoices at this time.";
            }
        }
    }
    render() {
        return (
            <div className="PaidInv">
                <Grid>
                    <Grid.Row centered>
                        <h2> {this.HandleHeader()}</h2>
                    </Grid.Row>
                    <Divider />
                    <Grid.Row centered />
                </Grid>
            </div>
        );
    }
}
export default PaidInv;



// WEBPACK FOOTER //
// ./src/components/accounting/invoices/paidinv.jsx